var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cell",
      staticStyle: { position: "relative" },
      attrs: { inert: _vm.isSaving },
    },
    [
      _vm.isSaving
        ? _c("div", { staticClass: "quote-incident-notes-overlay" })
        : _vm._e(),
      _c("article", { staticClass: "box" }, [
        _c("label", { staticClass: "label" }, [_vm._v("Incident Date")]),
        _c(
          "div",
          { staticClass: "field has-addons" },
          [
            _c("v-date-picker", {
              attrs: {
                "is-dark": _vm.$theme.isDark,
                masks: _vm.formats,
                attributes: _vm.attrs,
                locale: _vm.$userInfo.locale,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ inputValue, inputEvents }) {
                    return [
                      _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "control has-icons-left" }, [
                          _c(
                            "input",
                            _vm._g(
                              {
                                staticClass: "input",
                                attrs: {
                                  type: "text",
                                  placeholder: "Incident Date",
                                  readonly: "",
                                },
                                domProps: { value: inputValue },
                              },
                              inputEvents
                            )
                          ),
                          _c("span", { staticClass: "icon is-small is-left" }, [
                            _c("i", {
                              staticClass: "mdi mdi-calendar mdi-18px",
                            }),
                          ]),
                        ]),
                      ]),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.selectedIncidentNotesDate,
                callback: function ($$v) {
                  _vm.selectedIncidentNotesDate = $$v
                },
                expression: "selectedIncidentNotesDate",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Notes")]),
          _c("div", { staticClass: "control" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.incidentNotesText,
                  expression: "incidentNotesText",
                },
              ],
              staticClass: "textarea",
              attrs: { placeholder: "" },
              domProps: { value: _vm.incidentNotesText },
              on: {
                focus: _vm.captureNotesSnapshot,
                blur: _vm.handleNotesBlur,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.incidentNotesText = $event.target.value
                },
              },
            }),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }